import { handleResponseError } from "web_myplann/Infrastructure/Api/ApiUtils";

export function handleMyPlannResponseError(error: unknown) {
	handleResponseError(error);
}
